<!-- eslint-disable vue-a11y/click-events-have-key-events -->
<template>
  <ul
    v-if="visible"
    class="sam-breadcrumbs"
    data-samora
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      class="sam-breadcrumbs__item"
      :class="breadcrumbsItemClassObj(item)"
    >
      <div class="d-flex flex-center">
        <SamIcon
          v-if="index > 0"
          class="my-0 mx-2"
          icon="arrow-chevron-right"
          size="xs"
        ></SamIcon>
        <p
          class="text--caption"
          @click="triggerMenu(item)"
        >
          <span :bablic-exclude="item.dontTranslate">
            {{ getBreadcrumbText(item) }}
          </span>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import SamIcon from '../SamIcon/SamIcon.vue';

export default {
  name: 'SamBreadcrumbs',
  components: { SamIcon },
  props: {
    /**
     * Array of items for the Breadcrumbs (follows a defined structure)
     */
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    /**
     * If the Breadcrumbs are visible or not
     * @values true, false
     */
    visible: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    breadcrumbsItemClassObj(item) {
      return {
        'is-active': item.isActive,
        'is-disabled': item.disabled,
      };
    },
    triggerMenu(item) {
      /**
       * Triggers when a Breadcrumb item is clicked
       * @event click
       * @property {obj} item the item's Object
       */
      if (!item.disabled) {
        this.$emit('click', item);
      }
    },
    getBreadcrumbText(item) {
      let breadcrumbText = `${item.label}`;
      if (item.id) breadcrumbText += ` ${item.id}`;
      return breadcrumbText;
    },
  },
};
</script>

<style lang="scss" scoped>
.sam-breadcrumbs {
  @extend .m-0, .p-0, .d-flex, .flex-center;
  list-style: none;

  &__item {
    @extend .text--caption;

    &.is-active p {
      @include mix-weight--demi;
      color: $primary--black-rock;
    }

    &.is-disabled p {
      cursor: default !important;
      text-decoration: none !important;
    }

    div {
      position: relative;
    }

    &:not(.is-active) p:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
